/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_country = /** @type {(inputs: {}) => string} */ () => {
	return `Země`
};

const da_country = /** @type {(inputs: {}) => string} */ () => {
	return `Land`
};

const de_country = /** @type {(inputs: {}) => string} */ () => {
	return `Land`
};

const en_country = /** @type {(inputs: {}) => string} */ () => {
	return `Country`
};

const es_country = /** @type {(inputs: {}) => string} */ () => {
	return `País`
};

const fr_country = /** @type {(inputs: {}) => string} */ () => {
	return `Pays`
};

const hu_country = /** @type {(inputs: {}) => string} */ () => {
	return `Ország`
};

const it_country = /** @type {(inputs: {}) => string} */ () => {
	return `Paese`
};

const nl_country = /** @type {(inputs: {}) => string} */ () => {
	return `Land`
};

const pl_country = /** @type {(inputs: {}) => string} */ () => {
	return `Kraj`
};

const pt_country = /** @type {(inputs: {}) => string} */ () => {
	return `País`
};

const sv_country = /** @type {(inputs: {}) => string} */ () => {
	return `Land`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const country = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.country(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("country", locale)
	if (locale === "cs") return cs_country(inputs)
	if (locale === "da") return da_country(inputs)
	if (locale === "de") return de_country(inputs)
	if (locale === "en") return en_country(inputs)
	if (locale === "es") return es_country(inputs)
	if (locale === "fr") return fr_country(inputs)
	if (locale === "hu") return hu_country(inputs)
	if (locale === "it") return it_country(inputs)
	if (locale === "nl") return nl_country(inputs)
	if (locale === "pl") return pl_country(inputs)
	if (locale === "pt") return pt_country(inputs)
	return sv_country(inputs)
};